import React, { useState } from "react";
import { Lock, Navigation, ChevronLeft, ChevronRight, KeyRound } from "lucide-react";

const LINKS = [
  { href: "/admin", label: "Espace CRM", hint: "Gestion & planning", Icon: Lock, testid: "quick-access-crm" },
  { href: "/app", label: "Espace intervenant", hint: "Ma journée, pointages", Icon: Navigation, testid: "quick-access-app" },
];

/* Floating quick-access module (top right of the public site) so the CRM / field-app links never require scrolling. */
const QuickAccess = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed right-0 top-24 md:top-28 z-40 flex items-start" data-testid="quick-access">
      <button onClick={() => setOpen(!open)} aria-label={open ? "Réduire les accès rapides" : "Accès CRM et intervenant"} data-testid="quick-access-toggle"
        className={`flex items-center gap-1.5 bg-neutral-900 text-white text-xs font-semibold pl-2 pr-2.5 py-2.5 rounded-l-xl shadow-lg hover:bg-neutral-800 transition-colors ${open ? "rounded-r-none" : ""}`}>
        {open ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
        <KeyRound size={14} className="text-sky-300" />
        {!open && <span className="hidden sm:inline [writing-mode:vertical-rl] rotate-180 tracking-wide py-1">Accès</span>}
      </button>
      <div className={`overflow-hidden transition-[max-width,opacity] duration-300 ${open ? "max-w-[260px] opacity-100" : "max-w-0 opacity-0"}`}>
        <div className="bg-white/95 backdrop-blur-md border border-neutral-200 border-r-0 rounded-bl-xl shadow-xl p-2 w-[240px] space-y-1.5">
          {LINKS.map(({ href, label, hint, Icon, testid }) => (
            <a key={href} href={href} data-testid={testid} className="flex items-center gap-3 rounded-lg px-3 py-2.5 hover:bg-brand/5 group transition-colors">
              <span className="w-9 h-9 rounded-lg bg-neutral-900 text-white flex items-center justify-center group-hover:bg-brand transition-colors"><Icon size={16} /></span>
              <span className="min-w-0"><span className="block text-sm font-semibold text-neutral-900 leading-tight">{label}</span><span className="block text-[11px] text-neutral-500">{hint}</span></span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAccess;
